document.addEventListener('DOMContentLoaded', () => {
  const nthNumber = (number) => (number > 3 && number < 21 ? 'th' : ['th', 'st', 'nd', 'rd'][number % 10] || 'th');
  const getDayName = (date) => date.toLocaleDateString('en-GB', { weekday: 'long' }).toLowerCase();
  const isDateAllowed = (date) =>
    !deliveryConfig.excluded_days.includes(getDayName(date)) &&
    !deliveryConfig.excluded_dates.includes(date.toISOString().split('T')[0]);

  deliveryConfig.metafield_array.forEach((method, index) => {
    const parts = method.split(':');
    const name = parts[0];
    const courier_days = parts[1];
    let leadtime = deliveryConfig.leadtime;
    let days_to_add = 0;
    // ensure date and time is locked to UK
    let delivery_date = new Date(new Date().toLocaleString('en-GB', {timeZone: 'Europe/London', dateStyle: 'medium', timeStyle: 'long'}));

    /**
     * Step 1: Cutoff time
     * If we are before the cutoff time, lead time includes today
     * If after the cutoff time, lead time starts from tomorrow
     */
    const [targetHours, targetMinutes] = deliveryConfig.cutoff_time.split(':').map(Number);
    if (delivery_date.getHours() * 60 + delivery_date.getMinutes() < targetHours * 60 + targetMinutes) {
      leadtime -= 1;
    }

    // Step 2: Add lead time
    days_to_add += Number(leadtime);

    // Step 3: Add courier days
    days_to_add += Number(courier_days);

    let days_added = 0;
    // move date forward by required number of days
    while (days_added < days_to_add) {
      if (isDateAllowed(delivery_date)) {
        days_added++;
      }
      delivery_date.setDate(delivery_date.getDate() + 1);
    }
    // if final date lands on an excluded date or dates, move forward additional days
    while (!isDateAllowed(delivery_date)) {
      delivery_date.setDate(delivery_date.getDate() + 1);
    }
    const month = delivery_date.toLocaleDateString('en-GB', { month: 'long' });
    const date = `${getDayName(delivery_date)} ${delivery_date.getDate() + nthNumber(delivery_date.getDate())} ${month}`;

    let div = document.getElementById('estimated-shipping-method').content.cloneNode(true);
    div.querySelector('[data-role="method-name"]').innerText = name;
    div.querySelector('[data-role="method-date"]').innerText = date;
    if (deliveryConfig.images[index]) {
      const img = div.querySelector('img');
      img.src = deliveryConfig.images[index];
      img.alt = name;
      img.style.display = 'initial';
    }
    document.querySelector('.product__estimated-shipping').appendChild(div);
  });
});
